// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-accordion-main {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.title-accordion-main {
  text-align: center;
  font-style: normal;
  letter-spacing: -0.016px;
}
.title-accordion-main,
.accordionEditBtn,
.accordionSaveBtn,
.accordionCancelBtn {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}
.title-accordion-main,
.accordionEditBtn {
  color: #5f6d7e;
}
.container-accordion-main {
  flex-direction: column;
  width: 100%;
  gap: 16px;
  cursor: pointer;
  border-bottom: 1px solid var(--neutral-700, #d1d9e2);
}
.container-accordion-main.closed {
  border-bottom: none;
}
.ukupni-dolazak {
  margin-right: 84px;
}
.header-btn-add {
  background: none;
  border: none;
  margin-left: 24px;
  color: var(--gray-50, #5f6d7e);
  font-weight: 600;
  letter-spacing: -0.014px;
}
.header-btn-add,
.list-parent-accordion-card {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
}
.container-header-card-accordion {
  width: 100%;
  height: 45px;
  border-bottom: 1px solid var(--neutral-700, #d1d9e2);
}

.rotated {
  transform: rotate(180deg);
  transition: ease-in-out 0.3s;
}
.paginationContainer {
  border-left: 1px solid #d1d9e2;
  border-right: 1px solid #d1d9e2;
  border-bottom: 1px solid #d1d9e2;
  padding: 16px 0px;
}

.list-parent-accordion-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
  color: #5f6d7e;
  font-weight: 500;
  margin: 0;
}
.accordionRow {
  gap: 16px;
}
.accordionRow,
.accordionEditBtn,
.accordionSaveBtn,
.accordionCancelBtn,
.accordionBtnRow,
.bottom-foother-text-card,
.container-accordion-main,
.module-tabs,
.paginationContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.accordionEditBtn {
  border: 1px solid #d1d9e2;
  border-radius: 4px;
  letter-spacing: -0.001em;
  text-align: left;
  padding: 8px 16px 8px 16px;
  margin-bottom: 16px;
}
.accordionBtnRow {
  gap: 24px;
  width: 100%;
  padding-bottom: 24px;
}
.accordionSaveBtn,
.accordionCancelBtn {
  width: 15%;
  border: none;
  border-radius: 4px;
  padding: 8px 16px 8px 16px;
  letter-spacing: -0.001em;
  text-align: center;
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.accordionCancelBtn {
  background-color: #ebebeb;
  color: #808080;
}
.accordionSaveBtn {
  background-color: #cb9c2d;
  color: white;
}
.accordionCancelBtn:hover {
  background-color: #cccccc;
}
.accordionSaveBtn:hover {
  background-color: #b18828;
}
.list-item-accordion-card {
  margin-bottom: 10px;
  height: 64px;
  border-bottom: 1px solid var(--neutral-700, #d1d9e2);
  margin: 0;
}
.border-bottom-li {
  width: 100%;
  margin-left: 30px;
}
.attended-accordion,
.didnt-attend-accordion {
  margin-right: 86px;
}
.total-text {
  margin-left: 30px;
}
.hours-accordion {
  margin-right: 86px;
}
.didnt-attend-accordion {
  color: red;
}
.total-attendance,
.error-attendance,
.border-bottom-li,
.container-header-card-accordion,
.list-item-accordion-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.evaluacije-table-container {
  overflow-x: scroll;
}
.total-attendance,
.error-attendance {
  height: 64px;
  color: #5f6d7e;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.014px;
}
.total-attendance {
  background: #eaffea;
}
.error-attendance {
  background: #ffeaea;
}
.Dolazak-btn-add {
  background: none;
  border: none;
  margin-right: 64px;
  color: var(--gray-50, #5f6d7e);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.014px;
}
.clickable-info-text {
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  cursor: pointer;
  text-decoration: underline;
}
.topicNameLink {
  color: #5f6d7e;
  text-decoration: underline;
  cursor: pointer;
}
.footer-card-accordion {
  border-top: 1px solid #ccc;
}

.bottom-foother-text-card {
  gap: 16px;
  color: #5f6d7e;
}
.module-tabs {
  gap: 32px;
  height: 41px;
  border-bottom: 1px solid var(--neutral-700, #d1d9e2);
  overflow: auto;
}
.bottom-foother-text-card,
.module-button {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.module-button {
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  color: #95999e;
  padding: 0;
  font-size: 16px;
  margin-right: 10px;
  position: relative;
  text-decoration: none;
  transition: color 300ms ease-in-out;
}
.module-button.active {
  color: #5f6d7e;
  text-decoration: underline;
}
.disabledAccordion {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.info-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
}

@media screen and (max-width: 620px) {
  .attended-accordion,
  .didnt-attend-accordion {
    padding-left: 20px;
  }
}

@media screen and (max-width: 530px) {
  .title-accordion-main {
    padding: 0 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/CardAccordionMain/CardAccordion.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;;;;EAIE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,eAAe;EACf,oDAAoD;AACtD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;;;;;;;;;EASE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,oDAAoD;EACpD,SAAS;AACX;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;;;;;EAKE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;AACA;EACE,SAAS;EACT,YAAY;EACZ,oDAAoD;EACpD,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".card-accordion-main {\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n.title-accordion-main {\n  text-align: center;\n  font-style: normal;\n  letter-spacing: -0.016px;\n}\n.title-accordion-main,\n.accordionEditBtn,\n.accordionSaveBtn,\n.accordionCancelBtn {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n}\n.title-accordion-main,\n.accordionEditBtn {\n  color: #5f6d7e;\n}\n.container-accordion-main {\n  flex-direction: column;\n  width: 100%;\n  gap: 16px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--neutral-700, #d1d9e2);\n}\n.container-accordion-main.closed {\n  border-bottom: none;\n}\n.ukupni-dolazak {\n  margin-right: 84px;\n}\n.header-btn-add {\n  background: none;\n  border: none;\n  margin-left: 24px;\n  color: var(--gray-50, #5f6d7e);\n  font-weight: 600;\n  letter-spacing: -0.014px;\n}\n.header-btn-add,\n.list-parent-accordion-card {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  line-height: normal;\n}\n.container-header-card-accordion {\n  width: 100%;\n  height: 45px;\n  border-bottom: 1px solid var(--neutral-700, #d1d9e2);\n}\n\n.rotated {\n  transform: rotate(180deg);\n  transition: ease-in-out 0.3s;\n}\n.paginationContainer {\n  border-left: 1px solid #d1d9e2;\n  border-right: 1px solid #d1d9e2;\n  border-bottom: 1px solid #d1d9e2;\n  padding: 16px 0px;\n}\n\n.list-parent-accordion-card {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  flex-direction: column;\n  list-style-type: none;\n  padding: 0;\n  color: #5f6d7e;\n  font-weight: 500;\n  margin: 0;\n}\n.accordionRow {\n  gap: 16px;\n}\n.accordionRow,\n.accordionEditBtn,\n.accordionSaveBtn,\n.accordionCancelBtn,\n.accordionBtnRow,\n.bottom-foother-text-card,\n.container-accordion-main,\n.module-tabs,\n.paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.accordionEditBtn {\n  border: 1px solid #d1d9e2;\n  border-radius: 4px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  padding: 8px 16px 8px 16px;\n  margin-bottom: 16px;\n}\n.accordionBtnRow {\n  gap: 24px;\n  width: 100%;\n  padding-bottom: 24px;\n}\n.accordionSaveBtn,\n.accordionCancelBtn {\n  width: 15%;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px 8px 16px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.accordionCancelBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.accordionSaveBtn {\n  background-color: #cb9c2d;\n  color: white;\n}\n.accordionCancelBtn:hover {\n  background-color: #cccccc;\n}\n.accordionSaveBtn:hover {\n  background-color: #b18828;\n}\n.list-item-accordion-card {\n  margin-bottom: 10px;\n  height: 64px;\n  border-bottom: 1px solid var(--neutral-700, #d1d9e2);\n  margin: 0;\n}\n.border-bottom-li {\n  width: 100%;\n  margin-left: 30px;\n}\n.attended-accordion,\n.didnt-attend-accordion {\n  margin-right: 86px;\n}\n.total-text {\n  margin-left: 30px;\n}\n.hours-accordion {\n  margin-right: 86px;\n}\n.didnt-attend-accordion {\n  color: red;\n}\n.total-attendance,\n.error-attendance,\n.border-bottom-li,\n.container-header-card-accordion,\n.list-item-accordion-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.evaluacije-table-container {\n  overflow-x: scroll;\n}\n.total-attendance,\n.error-attendance {\n  height: 64px;\n  color: #5f6d7e;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.014px;\n}\n.total-attendance {\n  background: #eaffea;\n}\n.error-attendance {\n  background: #ffeaea;\n}\n.Dolazak-btn-add {\n  background: none;\n  border: none;\n  margin-right: 64px;\n  color: var(--gray-50, #5f6d7e);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -0.014px;\n}\n.clickable-info-text {\n  font-family: Inter;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.topicNameLink {\n  color: #5f6d7e;\n  text-decoration: underline;\n  cursor: pointer;\n}\n.footer-card-accordion {\n  border-top: 1px solid #ccc;\n}\n\n.bottom-foother-text-card {\n  gap: 16px;\n  color: #5f6d7e;\n}\n.module-tabs {\n  gap: 32px;\n  height: 41px;\n  border-bottom: 1px solid var(--neutral-700, #d1d9e2);\n  overflow: auto;\n}\n.bottom-foother-text-card,\n.module-button {\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.module-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  color: #95999e;\n  padding: 0;\n  font-size: 16px;\n  margin-right: 10px;\n  position: relative;\n  text-decoration: none;\n  transition: color 300ms ease-in-out;\n}\n.module-button.active {\n  color: #5f6d7e;\n  text-decoration: underline;\n}\n.disabledAccordion {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.info-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 20px;\n}\n\n@media screen and (max-width: 620px) {\n  .attended-accordion,\n  .didnt-attend-accordion {\n    padding-left: 20px;\n  }\n}\n\n@media screen and (max-width: 530px) {\n  .title-accordion-main {\n    padding: 0 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
